const OfficeCoordinate = () => import('@/views/Application/ContactUs/OfficeCoordinate');
const ExternalDirectory = () => import('@/views/Application/ContactUs/ExternalDirectory');
const OfficeDirectory = () => import('@/views/Application/ContactUs/OfficeDirectory');
const OfficeRepresentatives = () => import('@/views/Application/ContactUs/OfficeRepresentatives');
const LiveChat = () => import('@/views/Application/ContactUs/LiveChat');

export default [
  {
    path: '/dashboard/contact-us/office-coordinate',
    name: 'office-coordinate',
    component: OfficeCoordinate,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/dashboard/contact-us/external-directory',
    name: 'external-directory',
    component: ExternalDirectory,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/dashboard/contact-us/office-directory',
    name: 'office-directory',
    component: OfficeDirectory,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/dashboard/contact-us/office-directory/:officeId',
    name: 'office-representatives',
    component: OfficeRepresentatives,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/dashboard/contact-us/live-chat',
    name: 'live-chat',
    component: LiveChat,
    meta: {
      requiresAuth: true,
    },
  },
];
